import styled from '@style'

const Wrapper = styled.section`
  padding-top: 100px;
  padding-bottom: 100px;
  position: relative;
  background: ${(props) => props.theme.colors.section};
`

export default Wrapper
